import { Controller } from "@hotwired/stimulus"

// Light/dark toggle. The current theme is applied before first paint by an
// inline script in the layout <head>; this controller just flips + persists it.
export default class extends Controller {
  toggle() {
    const dark = !document.documentElement.classList.contains("dark")
    document.documentElement.classList.toggle("dark", dark)
    localStorage.setItem("theme", dark ? "dark" : "light")
    const meta = document.querySelector('meta[name="theme-color"]')
    if (meta) meta.content = dark ? "#0f172a" : "#f8fafc"
    window.dispatchEvent(new CustomEvent("theme:changed", { detail: { dark } }))
  }
}
